import { all, delay, fork, put, select, takeEvery, takeLatest } from "../../shared/SagaService";
import AppActions from "../App/actions";
import AuthActions from "../Auth/actions";
import LoggerActions from "./actions";
import { AppModalType } from '../../enums/AppModalType';

// // Log all actions and states after they are dispatched
// export function* watchAndLog() {
//     yield takeEvery('*', function* (action, context) {
//         const state = yield select();

//         console.log('watchAndLog action', action, context);
//         console.log('watchAndLog state after', state);
//     });
// }

// Listen to action that caused a 401 error in SagaService's call()
export function* enqueue401ActionLogger() {
    yield takeEvery(LoggerActions.LOGGER_ENQUEUE_ACTION_401_QUEUE, function* () {
        const actions401Queue = yield select(state => state.Logger.actions401Queue);

        console.log('LOGGER_ENQUEUE_ACTION_401_QUEUE action', actions401Queue);
    });
}

/**
 * Redispatch previously failed actions (due to 401 - session expired) after reauthentication
 * Logger's Architecture:
 * - when 401 error occurs, the action is enqueued in actions401Queue (in SagaService call)
 * - when reauthentication is successful, the actions are redispatched and the actions401Queue is cleared
 */
export function* reauthenticateSuccessRedispatchActions() {
    yield takeLatest(AuthActions.LOGIN_SUCCESS, function* () {
        let actions401Queue = yield select(state => state.Logger.actions401Queue);
        actions401Queue = actions401Queue.filter(action => !!action.type);

        // delay is needed to update the cookie for access token in AuthSaga - prevent infinte 401 error
        yield delay(200);

        // close session expired modal
        yield put({type: AppActions.CLOSE_APP_MODAL, modalType: AppModalType.SESSION_EXPIRED_MODAL});

        // dispatch previously failed actions
        yield all([
            ...actions401Queue.map(action => put(action)),
            put({ type: LoggerActions.LOGGER_CLEAR_ACTIONS_401_QUEUE }),
        ]);

        // console.log('REAUTHENTICATE_SUCCESS state after', actions401Queue);
    });
}

export default function* rootSaga() {
    yield all([
        // fork(watchAndLog),
        fork(enqueue401ActionLogger),
        fork(reauthenticateSuccessRedispatchActions),
    ]);
}
